import { apiRequest } from "./apiClient";
import { createActivity, getActivityActor } from "./activityService";
import { bagliHatirlaticilariSil } from "./linkedReminderService";
import { emitRestDataChanged } from "./restEventBus";
import { trackEngagementDataAdded } from "./engagementService";
import { recordMeaningfulReviewAction } from "./appReviewService";

const enc = (v) => encodeURIComponent(String(v || ""));

export const gorevleriGetirService = async (familyId) => {
  if (!familyId) return [];
  const data = await apiRequest(`/tasks/${enc(familyId)}`, { skipAndroidLiteHeader: true });
  return Array.isArray(data?.tasks) ? data.tasks : [];
};

export const gorevEkleService = async ({
  familyId,
  gorevAdi,
  gorevAciklama,
  gorevAtananlar,   // array: [uid1, uid2, ...]
  gorevAtanan,      // geriye uyumluluk: tekil uid (varsa)
  gorevSonTarih,
  gorevOncelik,
  gorevKategori,
  atananUyeler,     // array: [{ad, soyad, uid}, ...]
  atananUye,        // geriye uyumluluk: tekil üye
  tumAileSecili = false,
  tumAileEtiketi = "Tüm aile",
  tamAd,
  profilAvatar = null,
  user,
}) => {
  const kategori = gorevKategori || "Diğer";

  // Çoklu atama normalize et
  const uids  = Array.isArray(gorevAtananlar) && gorevAtananlar.length > 0
    ? gorevAtananlar
    : (gorevAtanan ? [gorevAtanan] : []);
  const uyeler = Array.isArray(atananUyeler) && atananUyeler.length > 0
    ? atananUyeler
    : (atananUye ? [atananUye] : []);
  const adlar = uyeler.map(u => `${u.ad || ""} ${u.soyad || ""}`.trim()).filter(Boolean);
  const isAllFamily = Boolean(tumAileSecili && uids.length > 1);
  const displayAd = isAllFamily ? tumAileEtiketi : (adlar[0] || "");
  const displayAdlar = isAllFamily ? [tumAileEtiketi] : adlar;

  const payload = {
    ad: gorevAdi,
    aciklama: gorevAciklama,
    atananUid:   uids[0] || null,
    atananAd:    displayAd,
    atananUids:  uids,
    atananAdlar: displayAdlar,
    atananScope: isAllFamily ? "all_family" : "members",
    isAllFamily,
    sonTarih: gorevSonTarih,
    oncelik: gorevOncelik,
    kategori,
    tamamlandi: false,
    createdAt: new Date().toISOString(),
    ekleyen: tamAd,
    ekleyenUid: user?.uid,
  };

  const data = await apiRequest(`/tasks/${enc(familyId)}`, {
    method: "POST",
    skipAndroidLiteHeader: true,
    body: JSON.stringify(payload),
  });
  const task = data?.task || payload;
  const id = task?.id || task?.firebaseId;
  trackEngagementDataAdded({ familyId, moduleKey: "tasks", itemId: id });
  emitRestDataChanged({ familyId, resource: "tasks", action: "added", item: task });

  // Görev ana isteği başarıyla tamamlandıktan sonra aktivite kaydını arka
  // planda oluştur. Aktivite servisi Android WebView'da yavaşladığında veya
  // geçici ağ sorunu yaşadığında Görev Oluştur butonunun dakikalarca beklemesini
  // ve başarılı görevin kullanıcıya başarısız görünmesini önler.
  void createActivity({
    familyId,
    type: "task_added",
    category: "tasks",
    actor: getActivityActor({ user, name: tamAd, avatar: profilAvatar }),
    payload: {
      taskName: gorevAdi,
      assignedTo: isAllFamily ? tumAileEtiketi : adlar.join(", "),
      priority: gorevOncelik,
      category: kategori,
      dueDate: gorevSonTarih,
    },
    targetPage: "gorev",
    targetId: id,
  }).catch((error) => {
    console.warn("Görev aktivite kaydı oluşturulamadı:", error?.message || error);
  });

  return id;
};

export const gorevTamamlaService = async ({ familyId, gorev, user, tamAd, profilAvatar = null }) => {
  const yeniDurumTamamlandi = !gorev.tamamlandi;
  const data = await apiRequest(`/tasks/${enc(familyId)}/${enc(gorev.id)}/toggle`, {
    method: "PATCH",
    skipAndroidLiteHeader: true,
    body: JSON.stringify({ tamamlandi: yeniDurumTamamlandi }),
  });
  const task = data?.task || { ...gorev, tamamlandi: yeniDurumTamamlandi };
  emitRestDataChanged({ familyId, resource: "tasks", action: "updated", item: task });

  if (yeniDurumTamamlandi) {
    void recordMeaningfulReviewAction(user?.uid, {
      trigger: "task_completed",
      moduleKey: "tasks",
      itemId: gorev?.id,
    }).catch(() => {});
    await createActivity({
      familyId,
      type: "task_completed",
      category: "tasks",
      actor: getActivityActor({ user, name: tamAd, avatar: profilAvatar }),
      payload: { taskName: gorev?.ad || "" },
      targetPage: "gorev",
      targetId: gorev?.id || "",
    });
  }
};

export const gorevSilService = async ({ familyId, gorevId, gorev, user, tamAd, profilAvatar = null }) => {
  await bagliHatirlaticilariSil({
    familyId,
    kaynak: "task",
    kaynakId: gorevId,
    reminderId: gorev?.reminderId,
    reminderIds: gorev?.reminderIds,
  });

  await apiRequest(`/tasks/${enc(familyId)}/${enc(gorevId)}`, { method: "DELETE", skipAndroidLiteHeader: true });
  emitRestDataChanged({ familyId, resource: "tasks", action: "deleted", itemId: gorevId });

  await createActivity({
    familyId,
    type: "task_deleted",
    category: "tasks",
    actor: getActivityActor({ user, name: tamAd, avatar: profilAvatar }),
    payload: { taskName: gorev?.ad || "" },
    targetPage: "gorev",
    targetId: gorevId,
  });
};
